import PropTypes from 'prop-types';
import React, { useState, useEffect, useCallback, useMemo } from 'react';

import Formsy from 'formsy-react';
import { Plus } from 'lucide-react';
import { toJS } from 'mobx';
import { Row, Col, Button, Label, FormGroup, SheetBody, SheetFooter, FormFooter, FormCard, FormBody, SimpleAlert, FormSection, DefaultTooltip, HeaderSearch } from 'twyne-new.ui'

import { useAppAlert } from '@Components/AppAlert';
import { useGlobalStore } from '@Stores/global';
import Input from 'components/form/Input';
import Select from 'components/form/Select';
import appStore from 'stores/app';
import history from 'utils/history';

import { useOfferStore } from '../store';

import AttributeModal from './AttributeModal';
import AttributesTable from './AttributesTable';
import Pixel from './Pixel';

class OfferForm extends React.Component {
  state = {
    active: true,
    site_id: appStore.site.id,
    activeTab: 'general',
    forms: [],
    postOptions: [],
    pixel_url: '',
    post_id: '',
    offerId: '',
    customFieldIndex: null,
    modal: false,
    action: 'add',
    attribute: null,
    postVersionDisabled: false,
    types: [
      { label: 'Static', value: 'static' },
      { label: 'Dynamic', value: 'dynamic' },
    ],
    search: '',
    searchFocus: false,
  }

  load() {
    const { isAttribute } = this.props
    this.setState({ isAttribute })

    const data = toJS(this.props.data);
    if (data) {
      data.forms = data.forms.map(form => ({ label: form.name, value: form.id }));
      this.setState(data);
    }
  }

  componentWillMount() {
    const { isAttribute } = this.props;
    const data = toJS(this.props.data);
    if (data) {
      data.forms = data.forms.map(form => ({ label: form.name, value: form.id }));
      this.setState(data);
    }
    this.setState({ modal: false, isAttribute })
  }

  componentWillReceiveProps(props) {
    const { isAttribute } = props
    this.setState({ isAttribute })
  }

  toggleTab = tab => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  handleSubmit = (data, isAttribute = false) => {
    data.forms = data.forms.map(form => form.value)
    this.props.handleSubmit(data, isAttribute);
  }

  handleValidSubmit = model => {
    const data = Object.assign(this.state, model)
    data.post_version_id = data.post_version_id || null
    this.handleSubmit(data)
  }

  handleCancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
    } else {
      history.goBack();
    }
  }

  handleCustomChange = (idx, key, value) => {
    const { custom } = this.state
    custom[idx][key] = value;
    this.setState({ custom })
  }

  handleClickRemoveCustom = idx => {
    let { custom } = this.state
    custom = custom.filter(item => item !== idx)
    this.setState({ custom })
  }

  handleFormsChange = values => {
    this.setState({ forms: values });
  }

  handleClickAddCustom = () => {
    const custom = this.state.custom || []
    custom.push({ key: "", value: "" })
    const customFieldIndex = custom.length - 1

    this.setState({
      custom,
      modal: true,
      customFieldIndex,
      action: 'add',
    })
  }

  handleEditAttribute = key => {
    let customFieldIndex
    let idx = 0
    for (const attribute of this.state.custom) {
      if (attribute.key === key) {
        customFieldIndex = idx
      }
      idx++
    }

    this.setState({
      customFieldIndex,
      modal: true,
      action: 'edit',
      attribute: this.state.custom[customFieldIndex],
    })
  }

  handleTypeChange = item => {
    this.setState({ type: item && item.value || null })
  }

  handleDeleteAttribute = key => {
    let { custom } = this.state
    custom = custom.filter(attr => attr.key !== key);

    const data = this.state
    data.custom = custom
    this.props.handleSubmit(data, true, true);
  }

  attributeTypes = [
    {
      label: "String",
      value: "string",
    },
    {
      label: "Select",
      value: "static-list",
    },
  ]

  Lander = ({ col }) => {
    const { siteSettings: { useThemeConfig } } = useGlobalStore()
    const sessionTypes = useThemeConfig('modules.session.types')
    const { getPosts } = useOfferStore()
    const [postVersions, setPostVersions] = useState([])
    const [versions, setVersions] = useState([])
    const { post_id, postOptions, post_version_id, postVersionDisabled } = this.state

    const versionAvailable = useMemo(() => (sessionTypes || []).reduce((versions, type) => {
      const { args, ...keys } = type
      Object.keys(keys).forEach(key => versions[key] = args?.targetPost)
      return versions
    }, {}), [sessionTypes])

    const loadPostOptions = useCallback(async () => {
      const posts = await getPosts()
      const postOptions = posts.rows.map(post => ({
        label: `[${post.content_type.toUpperCase()}][#${post.id}] - ${post.title} (${post.slug})`,
        value: post.id,
        disabled: !post.active,
        content_type: post.content_type,
        versions: post.versions.map(version => ({ label: `${version.description} (${version.builder ? 'DnD' : 'Legacy'} Version)`, value: version.id, disabled: !version.active })),
      }))

      this.setState({ postOptions })
    }, [getPosts])

    useEffect(() => {
      loadPostOptions()
    }, [loadPostOptions])

    useEffect(() => {
      setVersions([{ label: 'default', value: '' }, ...postVersions])
    }, [postVersions])

    const handleLanderChange = item => {
      const postVersionDisabled = item && item.content_type && !versionAvailable[item.content_type]
      this.setState({ post_version_id: '', postVersionDisabled })
      setPostVersions(item && item.versions || [])
    }

    useEffect(() => {
      if (post_id && postOptions && postOptions.length) {
        const { versions, content_type } = postOptions.find(p => p.value === post_id) || {}
        const postVersionDisabled = !versionAvailable[content_type]
        this.setState({ postVersionDisabled })
        if (versions) {
          setPostVersions(versions)
        }
      }
    }, [post_id, postOptions, versionAvailable])

    return <>
      <Col size={col / 2}>
        <FormGroup>
          <Label>Lander</Label>
          <Select name="post_id" options={postOptions} value={post_id} handleOnChange={handleLanderChange} required />
        </FormGroup>
      </Col>
      <Col size={col / 2}>

        <FormGroup>
          <Label>Version</Label>
          <DefaultTooltip triggerProps={{ className: 'text-left! justify-start!' }} content={postVersionDisabled && 'Only the default version is available for the selected lander.'}>
            <Select name="post_version_id" options={versions} value={post_version_id || ''} clearable={false} disabled={postVersionDisabled} />
          </DefaultTooltip>

        </FormGroup>
      </Col>
    </>
  }

  RedirectFlow = () => {
    const { lists: { posts: { items, useLoad } } } = useOfferStore()
    useLoad(useMemo(() => ({ content_type: 'page', term: 'active=true' }), []))

    const options = useMemo(() => items.map(post => ({
      label: `[${post.content_type.toUpperCase()}][#${post.id}] - ${post.title} (/${post.slug})`,
      value: post.id,
    })), [items])

    const handleChange = selected => {
      this.setState({
        flowCmsPostId: selected && selected.value || null,
      })
    }

    return <Col size="6">
      <FormGroup>
        <Label>Redirect Flow</Label>
        <Select clearable name="flowCmsPostId" options={options} value={this.state.flowCmsPostId} handleOnChange={handleChange} />
      </FormGroup>
    </Col>
  }

  renderGeneral = col => <Row>
    <Col size={col}>
      <FormGroup>
        <Label>Name</Label>
        <Input name="name" value={this.state.name || ''} required />
      </FormGroup>
    </Col>
    <Col size={col}>
      <FormGroup>
        <Label>Type</Label>
        <Select name="type" handleOnChange={this.handleTypeChange} options={this.state.types} value={this.state.type} required />
      </FormGroup>
    </Col>
    <this.Lander col={col} />
    <this.RedirectFlow />
  </Row>

  handleClickSidebarClose = () => {
    const custom = this.state.custom.filter(attribute => attribute.key.length)
    this.setState({
      modal: false,
      custom,
    })
  }

  renderOptions() {
    const { attribute } = this.state

    if (attribute.type !== 'static-list') return

    if (!attribute.options) {
      attribute.options = { "": "" }
    }

    const optionsKeys = Object.keys(attribute.options) || null
    const options = []

    for (const key of optionsKeys) {
      options.push(
        <Col size="6">
          <Input value={key} name="key" placeholder="Key" required />
          <Input value={attribute.options[key]} name="value" placeholder="Value" required />
        </Col>,
      )
    }

    return options
  }

  handleAddOption = () => { }

  Attributes = () => {
    const { handleError } = useAppAlert()
    const index = this.state.customFieldIndex >= 0 ? this.state.customFieldIndex : null
    const { search, searchFocus } = this.state
    const normalizedSearch = (search || '').trim().toLowerCase()
    const custom = this.state.custom || []
    const filteredCustom = custom.filter(attribute => {
      if (!normalizedSearch) {
        return true
      }

      return [
        attribute.key,
        attribute.label,
      ].some(value => (value || '').toLowerCase().includes(normalizedSearch))
    })

    const handleAttributeValidSubmit = model => {
      const data = this.state

      if (data.action === "add") {
        let attributeCount = 0
        for (const attribute of data.custom) {
          if (attribute.key === model.key) {
            attributeCount++
          }
        }

        if (attributeCount > 1) {
          handleError('Error', 'Attribute was not saved, duplicated key.');
          return
        } else {
          data.custom[data.custom.length - 1] = model
        }
      } else {
        data.custom = data.custom.map(attribute => {
          if (attribute.key === model.key) {
            attribute = Object.assign(attribute, model)
          }
          return attribute
        })
      }

      this.setState({ modal: false })
      this.handleSubmit(data, true);
    }

    return (
      <FormBody>
        <FormCard
          title='Attributes'
          headerButtons={
            <div className='flex items-center gap-2'>
              <HeaderSearch
                focused={searchFocus || !!search}
                onFocus={searchFocus => this.setState({ searchFocus })}
                value={search}
                onChange={search => this.setState({ search })}
              />
              <Button size='sm' color="accent" onClick={this.handleClickAddCustom}>
                <Plus size={14} />
                Add
              </Button>
            </div>
          }>
          <AttributesTable data={filteredCustom}
            handleEditAttribute={this.handleEditAttribute}
            handleDeleteAttribute={this.handleDeleteAttribute}
          />
          {this.state.modal && <AttributeModal
            onClickSidebarClose={this.handleClickSidebarClose}
            handleAttributeValidSubmit={handleAttributeValidSubmit}
            attribute={this.state.custom[index]}
            action={this.state.action}
          />
          }
        </FormCard>
      </FormBody>
    )
  }

  PixelContent = () => {
    const meta = this.state.meta || {}
    const { pixels = [] } = meta

    const handlePixels = pixels => {
      this.setState({ meta: { ...meta, pixels } })
    }

    return <Pixel pixels={pixels} onChange={handlePixels} />
  }

  CreateForm = () => <>
    <Formsy onValidSubmit={this.handleValidSubmit}>
      <SheetBody>
        {this.renderGeneral(12)}
        <Col className='mt-4'>
          <div className='flex justify-between items-center'>
            <FormSection>
              Pixels
            </FormSection>
            <Button color="accent" size='sm' onClick={this.handleAddPixel}>
              <Plus size={14} />
              Add
            </Button>
          </div>
          <this.PixelContent />
        </Col>
      </SheetBody>
      <SheetFooter>
        <Button onClick={this.handleCancel} variant='ghost'>Cancel</Button>
        <Button type="submit" color="accent">Save</Button>
      </SheetFooter>
    </Formsy>
  </>

  handleAddPixel = () => {
    const meta = this.state.meta || {}
    const { pixels = [] } = meta
    pixels.push({ url: '' })
    this.setState({ meta: { ...meta, pixels } })
  }

  EditForm = () => <>
    <Formsy onValidSubmit={this.handleValidSubmit}>
      <FormBody>
        <Row>
          <Col>
            <FormCard title='General'>
              {this.renderGeneral(6)}
            </FormCard>
          </Col>
          <Col>
            <FormCard title='Pixels' headerButtons={<>
              <Button size='sm' color="accent" onClick={this.handleAddPixel} >
                <Plus size={14} />
                Add
              </Button>
            </>}
              render={!!this.state?.meta?.pixels?.length}
            >
              <this.PixelContent />
            </FormCard>
          </Col>
        </Row>
        <FormFooter className='bottom-10'>
          <Button type="submit" color="accent">Save</Button>
          <Button onClick={this.handleCancel} variant='ghost'>Cancel</Button>
        </FormFooter>
      </FormBody>
    </Formsy>
  </>

  render() {
    if (this.state.id === undefined) {
      return <this.CreateForm />
    } else if (!this.state.isAttribute) {
      return <this.EditForm />
    } else {
      return <this.Attributes />
    }
  }
}

OfferForm.propTypes = {
  handleSubmit: PropTypes.func,
  data: PropTypes.any,
  isAttribute: PropTypes.bool,
};

export default OfferForm;
